import { gql } from '@apollo/client';

export const fetchResourceIdsFromContact = gql`
  query fetchResourceIdsFromContact($contactEmail: String, $contactType: [ContactType], $transactionAccountId: String) {
    resourcesByContact(
      contactEmail: $contactEmail
      contactType: $contactType
      transactionAccountId: $transactionAccountId
    ) {
      resourceId
      resourceType
    }
  }
`;
